import React, { useEffect, useRef, useState } from 'react'
import PageTabs from './partials/PageTabs'
import { useHistory, useLocation } from 'react-router-dom'
import { trans } from '../../../_providers/Translation'
import TextMessages from './text-messages/Index'
import PartStatusSms from './parts/Index'
import ReservationStatusSms from './reservations/Index'
import Help from '../../partials/Help'
import HelpInfo from './partials/HelpInfo'
import { Menu, MenuItem } from '@mui/material'
import adIcon from '@/assets/img/communication/icons/ad.svg'
import coworkersIcon from '@/assets/img/communication/icons/coworkers.svg'
import partsStatusesIcon from '@/assets/img/communication/icons/parts-statuses.svg'
import reservationsIcon from '@/assets/img/communication/icons/reservation-statuses.svg'

function Index(props) {
    const messageButtonRef = useRef(null)

    const location = useLocation()
    const history = useHistory()

    const searchParams = new URLSearchParams(location.search)

    const tabs = [
        {
            id: 'advert',
            name: trans('tabs.advertising'),
            name2: trans('tabs.advertisingMessage'),
            component: TextMessages,
            hasRef: true,
            status: 'advert',
            icon: adIcon
        },
        {
            id: 'team',
            name: trans('tabs.tofellow'),
            component: TextMessages,
            hasRef: true,
            status: 'team',
            icon: coworkersIcon
        },
        {
            id: 'parts',
            name: trans('headings.partStatusSms'),
            component: PartStatusSms,
            hasRef: true,
            icon: partsStatusesIcon
        },
        {
            id: 'reservations',
            name: trans('headings.reservationStatusSms'),
            component: ReservationStatusSms,
            hasRef: true,
            icon: reservationsIcon
        },

    ]

    const tab = searchParams.get('tab') ? searchParams.get('tab') : tabs[0].id

    const componentRef = useRef(null)

    const [state, setState] = useState({
        tab: '',
        index: null,
        loading: true,
        data: null
    })

    const [openButtonDropdown, setOpenButtonDropdown] = useState(null)

    const pendingAddRef = useRef(false)

    useEffect(() => {

        setState(prev => ({
            ...prev,
            loading: true,
            tab: tab,
            index: findTabIndex(tab)
        }))

    }, [location.search])

    // When a tab is selected from the message dropdown, trigger its add()
    // after the corresponding component has (re)rendered with the new status.
    useEffect(() => {
        if (!pendingAddRef.current) {
            return
        }

        pendingAddRef.current = false

        // Defer so the child component can update its props/state (e.g. status)
        // for the freshly selected tab before we open its add modal.
        const timeout = setTimeout(() => {
            handleAdd()
        }, 0)

        return () => clearTimeout(timeout)
    }, [state.index])

    const handleTab = id => {

        let index = findTabIndex(id)

        setState(prev => ({
            ...prev,
            tab: id,
            index: index
        }))

        history.push('?tab=' + id)
    }

    const findTabIndex = id => {
        let index = tabs.findIndex(t => {
            return t.id === id
        })

        return index
    }

    const handleAdd = () => {
        let modal = componentRef.current

        if (modal) {
            modal.add()
        }
    }

    const handleMenuItemClick = tab => {
        setOpenButtonDropdown(null)

        if (state.tab === tab.id) {
            // Already on the selected tab, just open its add modal.
            handleAdd()
        } else {
            // Switch to the selected tab first; the add() will be triggered
            // by the effect once the component has rendered for that tab.
            pendingAddRef.current = true
            handleTab(tab.id)
        }
    }

    function handleButtonSubmenuClick(e) {
        e.stopPropagation()
        e.preventDefault()

        setOpenButtonDropdown(messageButtonRef.current)
    }

    return (
        <div className="wrapper">
            <div className="top-part">
                <div className="left">
                    <h1 className="page-heading">
                        {trans('headings.sms-messages')} <Help modalStyle={{ maxWidth: '800px' }}><HelpInfo /></Help>
                    </h1>
                    <p className="page-subheading">
                        {trans('subheadings.sms-messages')}
                    </p>
                </div>
                {tabs[state.index] && tabs[state.index].hasRef
                    ?
                    <div className="right">
                        <button
                            className="button button-add with-dropdown"
                            onClick={handleAdd}
                            ref={messageButtonRef}
                        >
                            {trans('buttons.message')}
                            <i className="menu" onClick={handleButtonSubmenuClick}>

                            </i>
                        </button>
                        <Menu
                            anchorEl={openButtonDropdown}
                            keepMounted
                            open={Boolean(openButtonDropdown)}
                            onClose={() => setOpenButtonDropdown(null)}
                        >
                            {tabs.map((tab, index) => (
                                <MenuItem key={index} className="menu-option" onClick={() => handleMenuItemClick(tab)}>
                                    <img src={tab.icon} alt="" />
                                    {tab.name2 || tab.name || '-'}
                                </MenuItem>
                            ))}
                        </Menu>
                    </div>
                    :
                    ''
                }
            </div>

            <PageTabs
                tabs={tabs}
                tab={state.tab}
                handleTab={handleTab}
            />

            <div className='pannel'>
                {tabs[state.index] &&
                    React.createElement(tabs[state.index].component, {
                        ref: componentRef,
                        status: tabs[state.index].status,
                        name: tabs[state.index].name
                    })
                }
            </div>

        </div>
    )
}

export default Index